import {Component, ElementRef, OnInit} from '@angular/core';

import {StepsService} from "./services/steps.service";
import {HostListener} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {parse} from "jasmine-spec-reporter/built/configuration-parser";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    isShareholder = 0;

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {

        this.stepSrv.prevStep();
    }

    step: number;


    constructor(private stepSrv: StepsService, private translate: TranslateService, private elementRef: ElementRef) {
        this.isShareholder = parseInt(this.elementRef.nativeElement.getAttribute('isShareholder'));

    }

    ngOnInit() {
        this.stepSrv.step$.subscribe(step => {
            this.step = step;
        })

        if (window['language'] === 'pl') {
            this.translate.use(window['language']);

            this.translate.setTranslation('pl', this.translations);

        }

    }


    translations = {
        'Find your local reseller': 'Znajdź Resellera',
        'Select your country/region': 'Wybierz kraj/region',
        'Specify actions': 'Wybierz czynność',
        'Choose device': 'Wybierz urządzenie',
        'Select location': 'Wybierz kraj',
        'Featured Partners': 'Oficjalny Dystrybutor',
        'Official Distributors': 'Oficjalni Distrybutorzy',
        'Resellers with service points': 'Resellerzy prowadzący serwis',
        'Resellers': 'Resellerzy',
        'What you want to do?': 'Co chcesz zrobić?',
        'Purchase device, materials or parts': 'Kupić urządzenie, materiały lub części',
        'Service the device': 'Naprawić urządzenie',
        'Just show me all resellers in my country': 'Pokaż mi wszystkich resellerów w moim kraju',
        'Select the device, materials or parts you want to buy': 'Wybierz urządzenie, materiały lub części, które chcesz kupić',
        'Select the device you want to service': 'Wybierz urządzenie, które chcesz naprawić',
        'Select the device': 'Wybierz urządzenie',
        'Previous Step': 'Wstecz',
        'Please select a region': 'Wybierz swój region',
        'Partners Recommended by Zortrax': 'Partnerzy rekomendowani przez Zortrax',
        'Distributors who run service of Zortrax devices': 'Dystrybutorzy prowadzący serwis urządzeń Zortrax',
        'Resellers who run service of Zortrax devices': 'Resellerzy prowadzący serwis urządzeń Zortrax',
        'Resellers without service of Zortrax devices': 'Resellerzy nieprowadzący serwisu urządzeń Zortrax',
        'Distributors who run service of Zortrax industrial devices': 'Dystrybutorzy prowadzący serwis urządzeń Zortrax serii Industrial',
        'Visit website': 'Odwiedź stronę',
        'Currently, we do not have an Official Zortrax Reseller in the selected region. Check our offer in the online store.': 'Obecnie nie posiadamy oficjalnego Resellera Zortrax w wybranym regionie. Sprawdź naszą ofertę w sklepie internetowym.',
        'Currently, we do not have an Official Zortrax Service Center in the selected region. To contact with our service fill the form.': 'Obecnie nie posiadamy oficjalnego Centrum Serwisowego w wybranym regionie. W celu kontaktu z naszym serwisem wypełnij formularz:',
        'Any malfunctions of the Zortrax Apoller device must be reported directly to Zortrax. In order to contact our service team, fill in the form.': 'Wszelkie usterki dotyczące urządzenia Zortrax Apoller muszą być zgłaszane bezpośrednio do Zortrax. W celu kontaktu z naszym serwisem, wypełnij formularz.',
        'Currently, we do not have an Zortrax Authorised Service for Industrial Series Products in the selected region. In order to contact our service team, fill in the form.': 'Obecnie nie posiadamy oficjalnego Autoryzowanego Serwisu Zortrax Produktów Serii Industrial w wybranym regionie. W celu kontaktu z naszym serwisem wypełnij formularz:',
        'Currently, we do not have an Official Zortrax Industrial Distributor in the selected region. Check our offer in the online store.': 'Obecnie nie posiadamy oficjalnego Dystrybutora Zortrax Serii Industrial w wybranym regionie. Sprawdź naszą ofertę w sklepie internetowym.',
        'Go to Zortrax online store': 'Przejdź do Zortrax Store',
        'Go to Zortrax Support Form': 'Przejdź do Zortrax Support Form',
        'Service of Zortrax devices for the selected region is provided by:': 'Serwis urządzeń Zortrax na wybrany region prowadzi:',
        'Service': 'Serwis',
        'Purchase': 'Zakup',
    }


}
